import { SavingsWithdrawalBase } from 'app/containers/PipelineSection/Retirement/SavingsWithdrawalBase'
import * as utils from 'app/utils'
import * as moment from 'moment'
import * as React from 'react'

class RetirementSpouseWithdrawal extends SavingsWithdrawalBase {

  componentWillMount() {
    this.setup('spouse')
    this.onAppStateUpdate((appState) => {
      const profile = appState.Profile.getNative('info')
      this.person = profile.getSpouse()
      const personFirstNamePossessive = utils.personPossessive(this.person.firstName)
      this.savingsInputs = profile.getRetirementForSpouse()

      const ageContributionsStop = this.state.ageContributionsStop ? this.state.ageContributionsStop.clone() : moment.duration(65, 'years')
      const withdrawalAge = this.state.withdrawalAge ? this.state.withdrawalAge.clone() : moment.duration(65, 'years')

      this.setState({ personFirstNamePossessive, profile, ageContributionsStop, withdrawalAge })

      if (this.savingsInputs !== null) {
        this.updateSavings(profile)
      }
    })
  }

}

const RetirementSpouseWithdrawalQuestionsGroup = () => (
  <RetirementSpouseWithdrawal
    header="Withdrawal" icon="" />
)

export {
  RetirementSpouseWithdrawalQuestionsGroup
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/Retirement/SpouseWithdrawal/index.tsx